import { createTheme } from '@mui/material/styles';

export const blackIconTheme = createTheme({
    components: {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#000',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: '#000',
                },
            },
        },
    },
});